import {
  SET_LOGIN_AUTH,
  SET_LOGOUT_AUTH,
  INITIALIZE_APP,
  REFRESH_INVENTORY,
  INITIALIZE_USER_APP_DATA,
  UPDATE_USER_INFO,
  USER_TYPE,
  GROUP_ID,
  DEFAULT_CLINIC_ID,
  UPDATE_USER_PERMISSIONS,
  USER_GROUPS,
  SWITCH_TABS,
  SHOW_MESSAGE_ALERT,
  SET_DEFAULT_CLINIC_GROUP_AFTER_AUTH,
  SET_DEFAULT_TAB_AFTER_AUTH,
  SET_VERIFY_OTP_USER_DETAILS
} from './Index';

// For logging in the user
export const _login = (
  authToken: any,
  oauth: any,
  initialRoute: any
): any => async (dispatch: any) => {
  dispatch({type: SET_LOGIN_AUTH, payload: {authToken, oauth, initialRoute}});
};

export const _logout = (): any => async (dispatch: any) => {
  dispatch({type: SET_LOGOUT_AUTH, payload: {}});
};

export const _showMessageAlert = (showMessageAlert: any): any => async (
  dispatch: any
) => {
  dispatch({type: SHOW_MESSAGE_ALERT, payload: {showMessageAlert}});
};

export const _initApp = (config: any, data: any): any => async (
  dispatch: any
) => {
  dispatch({type: INITIALIZE_APP, payload: {config, data}});
};

export const _refreshInventoryData = (refresh: boolean): any => async (
  dispatch: any
) => {
  dispatch({type: REFRESH_INVENTORY, payload: {refresh}});
};

// INIT Logged In user info
export const _initUserInfo = (data: any): any => async (dispatch: any) => {
  dispatch({type: UPDATE_USER_INFO, payload: {data}});
};

export const _initUserPermissions = (data: any): any => async (
  dispatch: any
) => {
  dispatch({type: UPDATE_USER_PERMISSIONS, payload: {data}});
};

// Initialize the application with the user data, [user, clincList, selectedClinic]
// This dispatcher dispatches data for the user required to get the application flow
export const _initUserAppData = (data: any): any => async (dispatch: any) => {
  dispatch({type: INITIALIZE_USER_APP_DATA, payload: {data}});
};

export const _userType = (userType: any): any => async (dispatch: any) => {
  dispatch({type: USER_TYPE, payload: {userType}});
};

export const _groupId = (groupId: any): any => async (dispatch: any) => {
  dispatch({type: GROUP_ID, payload: {groupId}});
};

export const _defaultClinicId = (defaultClinicId: any): any => async (
  dispatch: any
) => {
  dispatch({type: DEFAULT_CLINIC_ID, payload: {defaultClinicId}});
};

export const _userGroups = (userOrgGroupList: {
  name: string;
  id: string | number;
  user_org_group_type: string;
}): any => async (dispatch: any) => {
  dispatch({type: USER_GROUPS, payload: {userOrgGroupList}});
};

export const _switchTabs = (switch_tab: any): any => async (dispatch: any) => {
  dispatch({type: SWITCH_TABS, payload: {switch_tab}});
};

export const _setDefaultGroupAfterAuth = (payload: {
  clinic_group_id: number | string | null;
}): any => async (dispatch: any) => {
  dispatch({type: SET_DEFAULT_CLINIC_GROUP_AFTER_AUTH, payload});
};

export const _setDefaultTabAfterAuth = (payload: {
  tab: string | null;
}): any => async (dispatch: any) => {
  dispatch({type: SET_DEFAULT_TAB_AFTER_AUTH, payload});
};

export const _setVerifyOTPUserDetails = (payload: {user: any}): any => async (
  dispatch: any
) => {
  dispatch({type: SET_VERIFY_OTP_USER_DETAILS, payload});
};
